export class Gifts_Order {
   constructor(piezas_regalo, monto_regalo){
      this.piezas_regalo = piezas_regalo
      this.monto_regalo = monto_regalo
   }
   static fromServiceOrderGifts (gifts_order) {
      return new Gifts_Order(
         gifts_order.piezas_regalo,
         gifts_order.monto_regalo
         );
   }   
}